import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			pageTitle: "Typing and Validating",
description: "Explains how Freon handles typing and validation through separate generators, their dependencies, and recommended usage.",
tags: [ "Freon", "typing", "validation", "language definition", "generator", "dependency", "build"] ,
modifiedTime: "2025-11-07T17:20:18.624Z",
publishedTime: "2025-11-07T17:20:18.624Z"
    }
  };
};